






















































import {
  ComponentInternalInstance,
  getCurrentInstance,
  reactive,
  ref,
  SetupContext,
  watch,
} from '@vue/composition-api';
import { InfoCircleIcon, CheckCircleFilledIcon, CloseCircleFilledIcon } from 'tdesign-icons-vue';
import internalServerSettingHandler from '@/renderer/components/dialog/setting/internalServerSettingHandler';
export default {
  name: 'SystemSetting',
  components: {
    InfoCircleIcon,
    CheckCircleFilledIcon,
    CloseCircleFilledIcon,
  },
  setup(props: any, context: SetupContext) {
    const {
      internalServerSetting,
      internalServerTestState,
      serverUrlRules,
      methods: internalServerMethods,
    } = internalServerSettingHandler();
    const serverUrlDisabled = ref(true);
    const serverUrlChange = () => {
      serverUrlDisabled.value = false;
      internalServerTestState.status = '';
      internalServerTestState.msg = '';
    };
    const testServerUrl = async () => {
      // 先检验完成后再进去验证
      const valid = await (context.refs.serverForm as any).validateOnly();
      if (typeof valid !== 'boolean') return;
      await internalServerMethods.testInternalServer();
    };
    return {
      internalServerSetting,
      internalServerTestState,
      internalServerMethods,
      serverUrlDisabled,
      serverUrlRules,
      serverUrlChange,
      testServerUrl,
    };
  },
};
